import { render, staticRenderFns } from "./dialog-2.vue?vue&type=template&id=3810156a&scoped=true&"
import script from "./dialog-2.vue?vue&type=script&lang=ts&"
export * from "./dialog-2.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-2.vue?vue&type=style&index=0&id=3810156a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810156a",
  null
  
)

export default component.exports